export const articleConstant = [
    {
        id: "0",
        title:"My software Notes: Internet - 1",
        explanation: "Network, internet, IP, domain name, DNS, TCP, WWW, HTTP, API vs web service",
        imgLink: "https://miro.medium.com/max/1050/1*YECeOxlko9KoOJNw8RNm3A.jpeg",
        mediumLink: "https://mesutcifci.medium.com/yazilim-notlari-internet-988e6d31f396",
        selected: false
    },
    {
        id: "1",
        title:"My JavaScript Notes — 1",
        explanation: "Thread of execution, execution context, call stack",
        imgLink: "https://miro.medium.com/max/1400/0*meAatR7b-fOqQrbp",
        mediumLink: "https://mesutcifci.medium.com/javascript-notlarim-1-4a430c0076c3",
        selected: false
    },
    {
        id: "2",
        title:"My JavaScript Notes — 2",
        explanation: "Scope, lexical scope, closure, [[Scope]], scope chain",
        imgLink: "https://miro.medium.com/max/1400/0*u6zEkfEoMljQF2y3",
        mediumLink: "https://mesutcifci.medium.com/javascript-notlarim-2-5536d0b13de3",
        selected: false
    },
    {
        id: "3",
        title:"My React Notes — 1",
        explanation: "Why React, imperative and declarative programing, SPA, components, JSX, wrapper element in React",
        imgLink: "https://miro.medium.com/max/1400/0*KzXdOULBfGpGUktu",
        mediumLink: "https://mesutcifci.medium.com/react-notlar%C4%B1m-1-664d4e052390",
        selected: false
    },
    {           
        id: "4",    
        title:"My React Notes — 2",
        explanation: "Composition, State, controlled and Uncontrolled component ",
        imgLink: "https://miro.medium.com/max/1400/0*FZcgM8aghnJLZtm0",
        mediumLink: "https://mesutcifci.medium.com/react-notlarim-2-e46b681b0f11",
        selected: false
    },
    {
        id:"5",
        title:"My React Notes — 3",
        explanation: "React Portal, useRef, side effect in React, useEffect, cleanup function, setTimeout and debouncing",
        imgLink: "https://miro.medium.com/max/1400/0*FZcgM8aghnJLZtm0",
        mediumLink: "https://mesutcifci.medium.com/react-notlarim-3-f9631d853507",
        selected: false
    },
    {
        id: "6",
        title:"My React Notes — 4",
        explanation: "useReducer, state, dispatch, reducer, initialSate, initFunction",
        imgLink: "https://miro.medium.com/max/1400/0*FZcgM8aghnJLZtm0",
        mediumLink: "https://mesutcifci.medium.com/react-notlarim-4-d5f9af31815c",
        selected: false
    },
 
]